<div
    [style.mask]="'url(https://cdn.catexpert.ab-inbev.com/assets/images/'+ icon +'.svg) no-repeat center / contain'"
    [style.-webkit-mask]="'url(https://cdn.catexpert.ab-inbev.com/assets/images/'+ icon +'.svg) no-repeat center / contain'"
    [style.padding]="padding"
    [style.background-color]="color"
    [matTooltip]="tooltip"
>
</div>
